// City hubs for Prosper's real service area. Copy is individually written per city (data/local/cities/*.json).
import { LOCAL_CITIES } from "./local";

export const CANONICAL_DOMAIN = "https://prosperdoorrepair.com";

const ctx = require.context("./local/cities", false, /\.json$/);
const load = (slug) => {
  const p = ctx(`./${slug}.json`);
  return {
    ...p,
    landmarks: (p.landmarks || []).map((l) => ({ name: l.name, note: l.note || l.blurb })),
    events: (p.events || []).map((e) => (typeof e === "string" ? e : `${e.name} — ${e.blurb}`)),
  };
};

export const CITIES = LOCAL_CITIES.map((c) => ({ ...c, isCounty: false, ...load(c.slug) }));

export const getCity = (slug) => CITIES.find((c) => c.slug === slug);
